import React, { useState, useEffect, memo } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { StepGroup, Step, StepContent, StepTitle } from './ui/stepper';

function processProps(path, currentItem) {
  let previousGroup = 'none';
  let nextPreviousGroup = previousGroup;
  const groups = {};
  for (let i = 0; i < path.length; i++) {
    const itemId = path[i].itemId;
    previousGroup = nextPreviousGroup;
    const groupName = path[i].group;
    nextPreviousGroup = groupName;
    if (groupName && groupName !== previousGroup) {
      groups[groupName] = { collapsed: true };
    }
    if (itemId === currentItem.id && groupName) {
      groups[groupName].collapsed = false;
    }
  }
  return groups;
}

function FormPath({ currentItem, items, path, canFreelyNavigate, onNavigate }) {
  const [processedGroups, setProcessedGroups] = useState(() =>
    processProps(path, currentItem)
  );

  useEffect(() => {
    setProcessedGroups(processProps(path, currentItem));
  }, [path, currentItem]);

  const toggleGroup = (groupName) => {
    setProcessedGroups((prev) => ({
      ...prev,
      [groupName]: { ...prev[groupName], collapsed: !prev[groupName].collapsed },
    }));
  };

  let previousGroup = 'none';
  let nextPreviousGroup = previousGroup;
  let foundCurrent = false;

  return (
    <StepGroup id="form-path">
      {path.map((pathItem, keyIndex) => {
        const item = items[pathItem.itemId];
        if (item === undefined) return <React.Fragment key={keyIndex} />;
        previousGroup = nextPreviousGroup;
        const groupName = pathItem.group;
        nextPreviousGroup = groupName;
        const collapsed = processedGroups[groupName]?.collapsed;
        const CollapseIcon = groupName && collapsed ? ChevronDown : ChevronUp;
        const isCurrentItem = item.id === currentItem.id && item.group === groupName;
        foundCurrent = foundCurrent || isCurrentItem;
        if (!canFreelyNavigate && !isCurrentItem && foundCurrent) {
          return null;
        }
        return (
          <React.Fragment key={'formPath-' + keyIndex}>
            {groupName && groupName !== previousGroup && (
              <Step isGroup key={groupName + keyIndex + '-group'}>
                <StepContent>
                  <StepTitle
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggleGroup(groupName)}
                    className="flex items-center justify-between"
                  >
                    <span>{groupName}</span>
                    <CollapseIcon className="w-3.5 h-3.5 opacity-60" />
                  </StepTitle>
                </StepContent>
              </Step>
            )}
            {(!groupName || collapsed === false) && (
              <Step
                onClick={() => onNavigate({ pathItem })}
                active={isCurrentItem}
                completed={!isCurrentItem}
              >
                <StepContent>
                  <StepTitle>{item.title}</StepTitle>
                </StepContent>
              </Step>
            )}
          </React.Fragment>
        );
      })}
    </StepGroup>
  );
}

export default memo(FormPath, (prev, next) => (
  prev.path === next.path &&
  prev.currentItem === next.currentItem &&
  prev.items === next.items &&
  prev.canFreelyNavigate === next.canFreelyNavigate
));
